import * as ActionTypes from '../actionTypes';
import apiActionCreator from '../../../common/service/api/actionCreator';
import {buildErrorMessage} from '../../../common/util/errorUtils';
import * as MessageActions from '../../../common/messageBox/actions/actions';

export const getWtsCourseDocs = (courseId) => apiActionCreator({
  'endpoint': `/wts/course/doc?courseId=${courseId}`,
  'authenticated': true,
  'types': [
    ActionTypes.FETCHING_WTS_COURSE_DOCS,
    ActionTypes.FETCHED_WTS_COURSE_DOCS,
    [
      ActionTypes.FETCHED_WTS_COURSE_DOCS_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});

export const createWtsCourseDoc = (courseId, data) => (dispatch) => {
  return dispatch(
    apiActionCreator({
      'endpoint': '/wts/course/doc',
      'authenticated': true,
      'types': [
        ActionTypes.CREATING_WTS_COURSE_DOC,
        [
          () => {
            dispatch(getWtsCourseDocs(courseId));
            return {'type': ActionTypes.CREATED_WTS_COURSE_DOC};
          },
          MessageActions.addMessageBoxInfo('Documento vinculado satisfactoriamente'),
        ],
        [
          ActionTypes.CREATED_WTS_COURSE_DOC_FAILED,
          (error) => buildErrorMessage(error),
        ],
      ],
      'microservice': 'part',
      'method': 'POST',
      'contentType': 'application/json',
      'data': data,
    })
  );
};

export const updateWtsCourseDoc = (courseId, docId, data) => (dispatch) => {
  return dispatch(
    apiActionCreator({
      'endpoint': `/wts/course/doc?docId=${docId}`,
      'authenticated': true,
      'types': [
        ActionTypes.UPDATING_WTS_COURSE_DOC,
        [
          () => {
            dispatch(getWtsCourseDocs(courseId));
            return {'type': ActionTypes.UPDATED_WTS_COURSE_DOC};
          },
          MessageActions.addMessageBoxInfo('Documento actualizado satisfactoriamente'),
        ],
        [
          ActionTypes.UPDATED_WTS_COURSE_DOC_FAILED,
          (error) => buildErrorMessage(error),
        ],
      ],
      'microservice': 'part',
      'method': 'PUT',
      'contentType': 'application/json',
      'data': data,
    })
  );
};

export const deleteWtsCourseDoc = (courseId, docId, mongoId) => (dispatch) => {
  return dispatch(
    apiActionCreator({
      'endpoint': `/wts/course/doc?docId=${docId}`,
      'authenticated': true,
      'types': [
        ActionTypes.DELETING_WTS_COURSE_DOC,
        [
          () => {
            if (mongoId) {
              dispatch(apiActionCreator({
                'endpoint': `/answers/${mongoId}`,
                'authenticated': true,
                'types': ['INACTIVATING_MONGO_DOC', 'INACTIVATED_MONGO_DOC', 'INACTIVATED_MONGO_DOC_FAILED'],
                'microservice': 'form',
                'method': 'PUT',
                'contentType': 'application/json',
                'data': {'status': 'inactive'},
              }));
            }
            dispatch(getWtsCourseDocs(courseId));
            return {'type': ActionTypes.DELETED_WTS_COURSE_DOC};
          },
          MessageActions.addMessageBoxInfo('Documento eliminado satisfactoriamente'),
        ],
        [
          ActionTypes.DELETED_WTS_COURSE_DOC_FAILED,
          (error) => buildErrorMessage(error),
        ],
      ],
      'microservice': 'part',
      'method': 'DELETE',
    })
  );
};

export const saveFormAndCreateDoc = (formData, courseId, componentType, fileName, user) => (dispatch) => {
  const docTypeMap = {
    'studyDocument': 'STUDY_MATERIAL',
    'quiz': 'QUIZ',
    'preEvaluationForm': 'PRE_EVALUATION',
  };

  return dispatch(apiActionCreator({
    'endpoint': '/answers',
    'authenticated': true,
    'types': [
      'SAVING_FORM',
      [
        (response) => {
          const mongoId = response?.data?.answerId?.['$oid'];// eslint-disable-line dot-notation
          if (mongoId) {
            dispatch(createWtsCourseDoc(courseId, {
              'course_id': courseId,
              'doc_type': docTypeMap[componentType] || 'OTHER',
              'file_name': fileName,
              'mongo_id': mongoId,
              'user_creation': user?.username || user?.id || 'SISTEMA',
            }));
          }
          return {'type': 'SAVED_FORM', 'payload': false};
        },
      ],
      [
        'SAVED_FORM_FAILED',
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'form',
    'method': 'POST',
    'data': formData,
  }));
};

export const getWtsCourseDocFile = (mongoId) => apiActionCreator({
  'endpoint': `/answers/${mongoId}`,
  'authenticated': true,
  'types': [
    ActionTypes.FETCHING_WTS_COURSE_DOC_FILE,
    ActionTypes.FETCHED_WTS_COURSE_DOC_FILE,
    [
      ActionTypes.FETCHED_WTS_COURSE_DOC_FILE_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'form',
  'method': 'GET',
});
export const clearWtsCourseDocs = () => ({'type': 'CLEAR_WTS_COURSE_DOCS'});
